export const FORM_TYPE = {
  TEXTBOX: 1,
  TEXTAREA: 2,
  CHECKBOX: 3,
  RADIO: 4,
  DROPDOWN: 5,
  DATEPICKER: 6,
  ARRAY_OBJECT: 7,
  SLOT: 8,
  DAY_HOURS_SELECTOR: 9,
  SALARY_RANGE: 10,
  HEADER: 11
};

export const ACTION_TYPE = {
  ADD: 1,
  UPDATE: 2,
  DELETE: 3
};

export const TEXTBOX_INPUT_TYPE = {
  TEXT: "TEXT",
  INTEGER: "INTEGER",
  POSITIVE_INTEGER: "POSITIVE_INTEGER",
  POSITIVE_DOUBLE: "POSITIVE_DOUBLE",
  DOUBLE: "DOUBLE"
};



// WEBPACK FOOTER //
// ./src/constants/custom-define-type.js